export default __webpack_public_path__ + "static/media/position-switcher-left.f23c96c2.svg";